export function testsCompareFunction(test1, test2) {
    const test1Data = test1.data();
    const test2Data = test2.data();
    if (test1Data.date_in === "A" && test2Data.date_in === "B") return -1;
    else if (test1Data.date_in === "B" && test2Data.date_in === "A") return 1;
    else return test1Data.course_name.localeCompare(test2Data.course_name);
}